import { Button } from '@/Atomic/Molecules/Button'

interface EmptyTimeEntryCellProps {
  onAdd: () => void
}

export const EmptyTimeEntryCell = ({ onAdd }: EmptyTimeEntryCellProps) => {
  return (
    <td className="time-entry-cell time-entry-cell-with-actions">
      <div className="time-entry-cell-with-actions">
        <div className="time-entry-content time-record-cell time-entry-empty-cell">
          <span className="empty-cell-dash">-</span>
        </div>
        <div className="time-record-actions">
          <Button
            variant="icon"
            icon="add-circle"
            size="sm"
            onClick={(e) => {
              e.stopPropagation()
              onAdd()
            }}
          />
        </div>
      </div>
    </td>
  )
}
